/**
 * Initialize the app scope from localStorage, migrating from old keys if needed.
 *
 * Priority: ano-scope (new) → migrate from ano-sidebar-mode + ano-workspace → "home"
 */
export function initializeScope(): string {
  const saved = localStorage.getItem("ano-scope");
  if (saved) return saved;
  // Migrate from old keys
  const oldMode = localStorage.getItem("ano-sidebar-mode");
  const oldWorkspace = localStorage.getItem("ano-workspace");
  if (oldMode === "workspace" && oldWorkspace) return oldWorkspace;
  return "home";
}

/**
 * Derive the selected workspace ID from scope.
 * "home" → null, anything else is treated as a workspace ID.
 */
export function deriveSelectedWorkspace(scope: string): string | null {
  return scope !== "home" ? scope : null;
}

/**
 * Persist scope to localStorage with backward-compat writes for old keys.
 */
export function persistScope(scope: string): void {
  localStorage.setItem("ano-scope", scope);
  const selectedWorkspace = deriveSelectedWorkspace(scope);
  if (selectedWorkspace) {
    localStorage.setItem("ano-workspace", selectedWorkspace);
    localStorage.setItem("ano-sidebar-mode", "workspace");
  } else {
    localStorage.removeItem("ano-workspace");
    localStorage.setItem("ano-sidebar-mode", "home");
  }
}
